/**
 * 模板变量页面路径
 */
export const VARIABLE_PAGE_PATH = '/templateVariable'
